/* Viva homepage motion. Every block is optional: each feature looks for its own markup and skips itself when absent.
   Re-runs when a section is edited in the theme editor. */
(function () {
  'use strict';
  if (window.__vivaHome) return;
  window.__vivaHome = true;
  var root = document.documentElement;
  root.classList.add('viva-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function clamp(v, a, b) { a = a === undefined ? 0 : a; b = b === undefined ? 1 : b; return Math.min(b, Math.max(a, v)); }

  var state = {};

  function init() {
    state = {
      hero: document.querySelector('.viva .hero'),
      heroMedia: document.querySelector('.viva .hero-media'),
      heroCopy: document.querySelector('.viva .hero-copy'),
      letters: $$('.viva .viva-letter-text'),
      par: $$('.viva [data-parallax]'),
      quotes: $$('.viva .cinema blockquote'),
      cards: $$('.viva .stack-card'),
      reads: $$('.viva .read'),
      readLinks: $$('.viva .reads-list a'),
      readImgs: $$('.viva .rframe img'),
      bioBox: document.querySelector('.viva .bio-topics'),
      promoBig: document.querySelector('.viva .promo-big'),
      qmNums: $$('.viva .qm-min b'),
      marquees: $$('.viva .marquee .track'),
      pending: [],
      offscreen: false
    };

    // letter: split into words once
    state.letters.forEach(function (lt) {
      if (lt.dataset.split) return;
      lt.dataset.split = 1;
      lt.innerHTML = lt.textContent.trim().split(/\s+/).map(function (w) { return '<span class="w">' + w + '</span>'; }).join(' ');
      if (reduce) $$('.w', lt).forEach(function (w) { w.classList.add('lit'); });
    });

    // reveal: only below-the-fold elements start hidden
    var vh = window.innerHeight;
    var io = ('IntersectionObserver' in window && !reduce) ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.remove('pre'); e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' }) : null;
    $$('.viva .rv, .viva [data-clip]').forEach(function (el) {
      if (el.dataset.rvInit) return;
      el.dataset.rvInit = 1;
      if (!io) { el.classList.add('in'); return; }
      if (el.getBoundingClientRect().top > vh * 0.92) {
        if (el.classList.contains('rv')) el.classList.add('pre');
        io.observe(el); state.pending.push(el);
      } else el.classList.add('in');
    });

    // follow-along strip: duplicate once for a seamless loop
    $$('.viva .ig-track').forEach(function (t) { if (!t.dataset.dup) { t.dataset.dup = 1; t.innerHTML += t.innerHTML; } });

    initCover();
    initFinder();
    initRails();
    onScroll();
  }

  // ---------- cover rotation ----------
  var cover = null;
  function initCover() {
    var hero = state.hero;
    if (!hero || !hero.querySelector('.hs')) { cover = null; return; }
    var slides = $$('.hs', hero), imgs = $$('.hs-img', hero), tabs = $$('.hs-tabs button', hero), pauseBtn = hero.querySelector('.hs-pause');
    cover = { cur: 0, userPaused: reduce, hovering: false, hidden: false };
    function sync() { hero.classList.toggle('paused', cover.userPaused || cover.hovering || cover.hidden || state.offscreen); }
    function go(n) {
      cover.cur = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var on = i === cover.cur; s.classList.toggle('on', on);
        if (on) { s.removeAttribute('aria-hidden'); s.inert = false; } else { s.setAttribute('aria-hidden', 'true'); s.inert = true; }
      });
      imgs.forEach(function (m, i) { m.classList.toggle('on', i === cover.cur); });
      tabs.forEach(function (b, i) {
        var on = i === cover.cur; b.classList.toggle('on', on);
        if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
        var f = b.querySelector('.bar b'); f.style.animation = 'none'; void f.offsetWidth; f.style.animation = '';
      });
    }
    cover.sync = sync;
    tabs.forEach(function (b, i) {
      b.addEventListener('click', function () { go(i); });
      b.querySelector('.bar b').addEventListener('animationend', function () { if (i === cover.cur && !reduce && slides.length > 1) go(cover.cur + 1); });
    });
    hero.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { cover.hovering = true; sync(); } });
    hero.addEventListener('pointerleave', function () { cover.hovering = false; sync(); });
    hero.addEventListener('focusin', function () { cover.hovering = true; sync(); });
    hero.addEventListener('focusout', function (e) { if (!hero.contains(e.relatedTarget)) { cover.hovering = false; sync(); } });
    document.addEventListener('visibilitychange', function () { cover.hidden = document.hidden; sync(); });
    if (pauseBtn) {
      var setPaused = function (p) { cover.userPaused = p; pauseBtn.setAttribute('aria-pressed', p); pauseBtn.setAttribute('aria-label', p ? 'Play rotation' : 'Pause rotation'); sync(); };
      pauseBtn.addEventListener('click', function () { setPaused(!cover.userPaused); });
      setPaused(cover.userPaused);
    }
    go(0);
  }

  // ---------- ritual finder ----------
  function initFinder() {
    $$('.viva .finder').forEach(function (sec) {
      var moods = $$('.mood', sec), panels = $$('.pairing', sec);
      moods.forEach(function (b, i) {
        b.addEventListener('click', function () {
          moods.forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
          panels.forEach(function (p, j) {
            if (j === i) { p.hidden = false; $$('.pair', p).forEach(function (el, k) { el.classList.add('swap'); setTimeout(function () { el.classList.remove('swap'); }, reduce ? 0 : 40 + k * 90); }); }
            else p.hidden = true;
          });
        });
      });
    });
  }

  // ---------- product rail arrows ----------
  function initRails() {
    $$('.viva [data-rail]').forEach(function (b) {
      if (b.dataset.bound) return; b.dataset.bound = 1;
      b.addEventListener('click', function () {
        var rail = b.closest('section').querySelector('.rail');
        if (rail) rail.scrollBy({ left: rail.clientWidth * 0.8 * +b.dataset.rail, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  // ---------- scroll ----------
  var lastY = window.scrollY, vel = 0, mqX = 0;
  function onScroll() {
    var y = window.scrollY, H = window.innerHeight, s = state;
    if (s.pending && s.pending.length) {
      s.pending = s.pending.filter(function (el) {
        if (el.getBoundingClientRect().top < H) { el.classList.remove('pre'); el.classList.add('in'); return false; }
        return true;
      });
    }
    // long reads: active story and its reading bar (runs even with reduced motion)
    if (s.reads && s.reads.length) {
      var act = 0;
      s.reads.forEach(function (r, i) {
        var b = r.getBoundingClientRect(); if (b.top < H * 0.55) act = i;
        if (s.readLinks[i]) s.readLinks[i].style.setProperty('--p', clamp((H * 0.55 - b.top) / b.height));
      });
      s.readLinks.forEach(function (a, i) { a.classList.toggle('on', i === act); });
    }
    if (reduce) return;
    // cover closes into a frame
    if (s.hero && s.heroMedia) {
      var hp = clamp(y / s.hero.offsetHeight), ins = hp * 5;
      s.heroMedia.style.clipPath = 'inset(' + ins + '% ' + ins + '% 0% ' + ins + '% round 0 0 ' + (hp * 36) + 'px ' + (hp * 36) + 'px)';
      if (s.heroCopy) { s.heroCopy.style.transform = 'translateY(' + (-hp * 90) + 'px)'; s.heroCopy.style.opacity = 1 - hp * 1.1; }
      var off = hp > 0.85;
      if (off !== s.offscreen) { s.offscreen = off; if (cover && cover.sync) cover.sync(); }
    }
    // editor's letter brightens word by word
    s.letters.forEach(function (lt) {
      var r = lt.getBoundingClientRect(), words = $$('.w', lt);
      var n = Math.round(clamp((H * 0.85 - r.top) / (r.height + H * 0.35)) * words.length);
      words.forEach(function (w, i) { w.classList.toggle('lit', i < n); });
    });
    s.par.forEach(function (img) {
      var b = img.parentElement.getBoundingClientRect(), c = (b.top + b.height / 2 - H / 2) / H;
      img.style.transform = 'translateY(' + (-c * parseFloat(img.dataset.parallax) * 100) + '%)';
    });
    s.readImgs.forEach(function (img) {
      var b = img.getBoundingClientRect(), k = clamp((H - b.top) / (H + b.height));
      img.style.transform = 'scale(' + (1.12 - k * 0.12) + ')';
    });
    if (s.bioBox) {
      var bb = s.bioBox.getBoundingClientRect(), lis = $$('li', s.bioBox), bp = clamp((H * 0.85 - bb.top) / (H * 0.5));
      lis.forEach(function (li, i) { li.style.setProperty('--p', clamp(bp * lis.length - i)); });
    }
    if (s.promoBig) {
      var pb = s.promoBig.parentElement.getBoundingClientRect();
      if (pb.bottom > 0 && pb.top < H) s.promoBig.style.transform = 'translateX(' + (-(H - pb.top) * 0.25) + 'px)';
    }
    s.qmNums.forEach(function (el) {
      if (el.dataset.done) return;
      if (el.getBoundingClientRect().top < H * 0.9) {
        el.dataset.done = 1;
        var to = +el.dataset.to, t0 = performance.now();
        (function step(now) { var k = clamp((now - t0) / 900); el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); })(t0);
      }
    });
    s.quotes.forEach(function (q) {
      var r = q.getBoundingClientRect(), qc = clamp(1 - Math.abs((r.top + r.height / 2 - H / 2) / H));
      q.style.transform = 'scale(' + (0.92 + qc * 0.08) + ')';
      var glow = q.closest('.cinema').querySelector('.glow');
      if (glow) glow.style.transform = 'translate(-50%,calc(-50% + ' + ((r.top - H / 2) * -0.25) + 'px))';
    });
    s.cards.forEach(function (c, i) {
      var next = s.cards[i + 1];
      if (!next) { c.style.transform = ''; c.style.filter = ''; return; }
      var nb = next.getBoundingClientRect(), cb = c.getBoundingClientRect(), cover_ = clamp((cb.bottom - nb.top) / cb.height);
      c.style.transform = 'scale(' + (1 - cover_ * 0.06) + ')'; c.style.filter = 'brightness(' + (1 - cover_ * 0.12) + ')';
    });
    vel += (y - lastY) * 0.12; lastY = y;
  }

  function tick() {
    if (!reduce && state.marquees && state.marquees.length) {
      vel *= 0.92;
      state.marquees.forEach(function (mq) {
        var half = mq.scrollWidth / 2;
        mqX -= (0.6 + Math.abs(vel)) * (vel < -0.05 ? -1 : 1);
        if (mqX <= -half) mqX += half; if (mqX > 0) mqX -= half;
        mq.style.transform = 'translateX(' + mqX + 'px) skewX(' + clamp(vel * -0.6, -8, 8) + 'deg)';
      });
    }
    requestAnimationFrame(tick);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  requestAnimationFrame(tick);
})();
